import React from 'react';
import { useTheme } from 'styled-components';
import * as Styled from './styles';
import { OptedInStatus, OptedInStatusLabels } from './types';

interface IStatusBadge {
  status: OptedInStatus;
}

const getStatusColors = (status: OptedInStatus, theme: any) => {
  switch (status) {
    case OptedInStatus.Yes:
      return {
        background: theme.colors.lightGreen,
        color: theme.colors.darkGreen,
        border: theme.colors.darkGreen,
      };
    case OptedInStatus.No:
      return {
        background: theme.colors.lightRed,
        color: theme.colors.red,
        border: theme.colors.red,
      };
    default: // Pending, NotSent, NA, Expired
      return {
        background: theme.colors.lightOrange,
        color: theme.colors.darkOrange,
        border: theme.colors.darkOrange,
      };
  }
};

export const StatusBadge = ({ status }: IStatusBadge) => {
  const theme = useTheme();
  const colors = getStatusColors(status, theme);
  
  return (
    <Styled.CenteredContainer>
      <Styled.BadgeWrapper $background={colors.background} $color={colors.color} $border={colors.border}>
        {OptedInStatusLabels[status]}
      </Styled.BadgeWrapper>
    </Styled.CenteredContainer>
  );
};
